// https://medium.com/codeep-io/how-to-use-google-recaptcha-with-react-38a5cd535e0dimport 
// https://github.com/ai/nanoid

import React from 'react';

import { createMedia } from "@artsy/fresnel";

import { Header, Grid, Label, Segment, Divider, Button, Confirm, Icon, Image, Message, Form, Input, Dropdown } from 'semantic-ui-react'
import 'semantic-ui-css/semantic.min.css'
import { ReCaptcha } from 'react-recaptcha-google'

// firebase connection
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, doc, getDoc, setDoc, addDoc } from 'firebase/firestore/lite';

import PreRegisterConfirm from './PreRegisterConfirm';
import './PreRegisterForm.css';

import gscLogo from './media/logo-gex-ski-club.jpg';


// for dev simulation
var dev = false;

// responsive breakpoints

const AppMedia = createMedia({
  breakpoints: {
    mobile: 320,
    tablet: 768,
    computer: 992,
    largeScreen: 1200,
    widescreen: 1920
  }
});

const mediaStyles = AppMedia.createMediaStyle();
const { Media, MediaContextProvider } = AppMedia;



// list of values init
var countryOptions = [ { key: 'fr', value: 'fr', flag: 'fr', text: 'France' }, { key: 'ch', value: 'ch', flag: 'ch', text: 'Suisse' }  ];
var identityOptions = [ { key: 'ID_CARD', value: 'ID_CARD', text: 'Carte d\'identité' }, { key: 'ID_PASSPORT', value: 'ID_PASSPORT',  text: 'Passport' }, { key: 'ID_OTHER', value: 'ID_OTHER',  text: 'Autre' }  ];
var shoeSizeOptions = [ {text: 'MONDOPOINT <-> EUR'}, {text: '16.5 <-> 26'}, {text: '17.5 <-> 27.5'}, {text: '18 <-> 28'}, {text: '19 <-> 29.5/30'}, {text: '19.5 <-> 31'}, {text: '20 <-> 31.5/32'}, {text: '20.5 <-> 32.5'}, {text: '21 <-> 33'}, {text: '22 <-> 35'}, {text: '22.5 <-> 36'}, {text: '23 <-> 36.5'}, {text: '23.5 <-> 36.6'}, {text: '24 <-> 38'}, {text: '24.5 <-> 39'}, {text: '25 <-> 39.5'}, {text: '25.5 <-> 40'}, {text: '26 <-> 41.5'}, {text: '27 <-> 42'}, {text: '27.5 <-> 43/43.5'}, {text: '28 <-> 44'}, {text: '28.5 <-> 44.5'}, {text: '29 <-> 45'}, {text: '29.5 <-> 46'}];


class PreRegisterForm extends React.Component { 

  state = { config: {status: 'UNKNOWN'}, articles: [{description:"", price:""}], vendor: {}, form: { error: 0,
                                                                        articledescerr: 0,
                                                                        articlepriceerr: 0,
                                                                        posted: false,
                                                                        firstname: {error: false, errormsg: ''},
                                                                        lastname: {error: false, errormsg: ''},
                                                                        email: {error: false, errormsg: ''},
                                                                        address_1: {error: false, errormsg: ''},
                                                                        address_2: {error: false, errormsg: ''},
                                                                        address_3: {error: false, errormsg: ''},
                                                                        zipcode: {error: false, errormsg: ''},
                                                                        city: {error: false, errormsg: ''},
                                                                        countrycode: {error: false, errormsg: ''},
                                                                        idtype: {error: false, errormsg: ''},
                                                                        idnumber: {error: false, errormsg: ''},
                                                                        articleslist: {overview: {error: false, errormsg: ''}, list:[{description_error: false, description_errormsg: '', description_size: 'max 55', description_size_alert: 'grey', price_error: false, price_errormsg: '', deleteConfirm: false}] },
                                                                        save: {content: 'Enregister les articles'}}
          } // end state

  logState = () => {
    console.log('log state:', this.state);
  } // end logState()

  constructor(props, context) {

    //init
    super(props, context);
    
    // variables
    let config = this.state.config;
    let articles = this.state.articles;
    let vendor = this.state.vendor;
    let form = this.state.form;

    // firebase setup
    console.log("init firebase config");

    var dbconfig = {
      apiKey: "AIzaSyA-ooj6Q6Z778EzSEIe8G4mEg04pZhtcWs",
      authDomain: "bourseskigex.firebaseapp.com",
      databaseURL: "https://bourseskigex.firebaseio.com",
      projectId: "bourseskigex",
      storageBucket: "bourseskigex.appspot.com",
      messagingSenderId: "802087787269"
    };

    // firebase connection
    const firebaseapp = initializeApp(dbconfig);
    const db = getFirestore(firebaseapp);
    //console.log("db: ");
    //console.log(db);


    /* multiple document retrieval sample
    const docsQuerySnapshot = getDocs(collection(db, "config")).then(
      (docs) => {
        console.log("getDocs (size): " + docs.size);
      }
    );
    */
    
    /* single document retrieval sample
    const configDoc = getDoc(doc(db, "config", "current-year")).then(
      (doc) => {
        console.log("configDoc: ", doc);
        console.log("configDoc::current_year: ", doc.data());
      }
    );
    */

    const configDoc = getDoc(doc(db, "config", "current-year")).then(
      (configref) => {
        console.log('configref: ', configref.data().status);
        let config = this.state.config;
        config = configref.data();
        console.log('status: ', config.status);
        console.log('config: ', config);
        this.setState( {config: config, articles: articles, vendor: vendor, form: form } )
        console.log('status: ', this.state.config.status);
        this.logState();
      }).then(
        
      );

      if (this.state.config.status === 'PREOPEN') {
        console.log('status is PREOPEN ');
        this.config.status = "PREOPEN"
        this.setState( {config: config, articles: articles, vendor: vendor, form: form } )
        this.logState();
      }

  } // end constructor


  componentDidMount() {
    if (this.captchaDemo) {
        console.log("started, just a second...")
        this.captchaDemo.reset();
    }
  }

  verifyCallback(recaptchaToken) {
    // Here you will get the final recaptchaToken!!!  
    console.log(recaptchaToken, "<= your recaptcha token")
  }

  showRemoveArticleConfirm = (e, data) => {
    let config = this.state.config;
    let articles = this.state.articles;
    let vendor = this.state.vendor;
    let form = this.state.form;

    form.articleslist.list[data.artid].deleteConfirm = true;
    console.log('displaying delete confirm panel for item', data.artid);
    this.setState(  {config: config, articles: articles, vendor: vendor, form: form } );

  }

  hideRemoveArticleConfirm = (e, data) => {
    let config = this.state.config;
    let articles = this.state.articles;
    let vendor = this.state.vendor;
    let form = this.state.form;

    form.articleslist.list[data.artid].deleteConfirm = false;
    console.log('displaying delete confirm panel for item', data.artid);
    this.setState(  {config: config, articles: articles, vendor: vendor, form: form } );

  }
  removeArticle = (e, data) => {
    let config = this.state.config;
    let vendor = this.state.vendor;
    let form = this.state.form;

    //TODO form is not cleaned for form state (should be ok now, pending test)
    this.state.form.articleslist.list.filter(function(_, i) { 
      return i !== data.artid;
    });
    form.articleslist.list[data.artid].deleteConfirm = false;

    this.setState( {config: config, articles: this.state.articles.filter(function(_, i) { 
      return i !== data.artid;
    }), vendor: vendor, form: form} );

  }

  addArticle = (e) => {
    let config = this.state.config;
    let vendor = this.state.vendor;
    let form = this.state.form;
    let list = [...form.articleslist.list, {description_error: false, description_errormsg: '', price_error: false, price_errormsg: '', deleteConfirm: false}];

    form.articleslist.error = false;
    form.articleslist.list = list;
    
 
    this.setState((prevState) => ({
      config: config, articles: [ ...prevState.articles, {description:"", price:""}], vendor: vendor, form: form
      }));
  }

  handleChange = (e) => {
    this.logState();
    let config = this.state.config;
    let articles = [...this.state.articles];
    let vendor = this.state.vendor;
    let form = this.state.form;

    console.log('handleChange > e: ', e);
    console.log('handleChange > e.target: ', e.target);
    console.log('handleChange > e.target.id: ', e.target.id);
    console.log('handleChange > e.target.parent: ', e.target.parent);
    console.log('handleChange > e.target.class: ', e.target.class);
    console.log('handleChange > e.target.className: ', e.target.className);
    console.log('handleChange > e.target.dataset.id: ', e.target.dataset.id);
    console.log('handleChange > e.target.value: ', e.target.value);
    console.log('handleChange > e.target.id.includes(_description_) : ', e.target.id.includes('description') );

    if (e.target.id !== 'undefined' && (e.target.id.includes('description') || e.target.id.includes('price')) ) {
      console.log('id is in');
      var art = e.target.id.split('-');
      console.log('field (art[0])', art[0]);
      console.log('index (art[1])', art[1]);
      articles[art[1]][art[0]] = e.target.value
      console.log('handleChange > changed article: ', e.target.value);
      if (art[0] === 'description') {
        
        if (e.target.value.length > 55) {
          articles[art[1]][art[0]] = e.target.value.slice(0,-1);
          console.log('description too long, slicing', e.target.value.slice(0,-1));
          console.log('articles: ', articles);
          form.articleslist.list[art[1]].description_size_alert = 'orange'
        } else {
          form.articleslist.list[art[1]].description_size_alert = 'grey'
        }
        form.articleslist.list[art[1]].description_size = articles[art[1]][art[0]].length + '/55'
      }

      //this.setState({ articles })
      this.setState({ config: config, articles: articles, vendor: vendor, form: form  });
    } else {
      console.log('id is NOT in');
      console.log('handleChange > changed vendor: ', e.target.name);
      vendor[e.target.name]= e.target.value;
      this.setState({ config: config, articles: articles, vendor: vendor, form: form });
    }
    /*
    if (["description", "price"].includes(e.target.className) ) {
      articles[e.target.dataset.id][e.target.className] = e.target.value
      console.log('handleChange > changed article: ', e.target.value);
      //this.setState({ articles })
      this.setState({ articles: articles, vendor: vendor, form: form  });
    } else {
      console.log('handleChange > changed vendor: ', e.target.name);
      vendor[e.target.name]= e.target.value;
      this.setState({ articles: articles, vendor: vendor, form: form });
    }
    */
  }

    handleChangeCountry = (e, select) => {
      let config = this.state.config;
      let articles = [...this.state.articles];
      let vendor = this.state.vendor;
      let form = this.state.form;

      console.log('countrycode:', select);
      vendor.countrycode = select.value;
      this.handleCountryCodeChange(true);
      this.setState({ config: config, articles: articles, vendor: vendor, form: form });

  }

  handleChangeIdType = (e, select) => {
    let config = this.state.config;
    let articles = [...this.state.articles];
    let vendor = this.state.vendor;
    let form = this.state.form;

    console.log('handleChangeIdType / idtype:', select);
    vendor.idtype = select.value;
    this.handleIdTypeChange(true)
    this.setState({ config: config, articles: articles, vendor: vendor, form: form });

  }

  testfunc = () => {
    this.logState();
  }

  // 
  // should be replaced by spected validation library
  formValidationRules = (name) => {
    let validation = {};
    switch (name) {
      case 'firstname':
        validation = {name: 'le prénom', mandatory: true, maxlength: 62 };
        break;
      case 'lastname':
        validation = {name: 'le nom', mandatory: true, maxlength: 62 };
        break;
      case 'email':
        validation = {name: 'l\'email', mandatory: true, maxlength: 62 };
        break;
      case 'address_1':
        validation = {name: 'l\'adresse postale', mandatory: true, maxlength: 62 };
        break;
      case 'address_2':
        validation = {name: 'l\'adresse postale (2)', mandatory: false, maxlength: 62 };
        break;
      case 'address_3':
        validation = {name: 'l\'adresse postale (3)', mandatory: false, maxlength: 62 };
        break;
      case 'zipcode':
        validation = {name: 'le code postal', mandatory: true, maxlength: 5 };
        break;
      case 'city':
        validation = {name: 'la ville', mandatory: true, maxlength: 62 };
        break;
      case 'idnumber':
        validation = {name: 'le numéro de justificatif d\'identité', mandatory: true, maxlength: 15 };
        break;
      default:
        validation = {};
        break;
    }
    console.log('validation rule for ' + name +' is:', validation);
    return validation;
  }

  handleTextInputChange = (e) => {

    let config = this.state.config;
    let articles = [...this.state.articles];
    let vendor = this.state.vendor;
    let form = this.state.form;

    let elname = '';
    console.log('handleTextInputChange, start');
    console.log('handleTextInputChange, received ', e);
    if (e.constructor.name === 'SyntheticEvent' ) {
      vendor[e.target.name]= e.target.value;
      console.log('handleTextInputChange, SyntheticEvent ', e.target.name);
      elname = e.target.name;
    } else {
      console.log('handleTextInputChange, SyntheticEvent ', e);
      elname = e;

    }
    console.log('handleTextInputChange, validating (elname): ', elname);
    console.log('handleTextInputChange, validating (vendor[elname]): ', vendor[elname]);

    var validator = this.formValidationRules(elname);
    console.log('handleTextInputChange, validator: ', validator);

    //if (this.state.form[elname].error || e.constructor.name === 'SyntheticEvent') {
    if (this.state.form[elname].error || e.constructor.name === 'String') {
        if (validator.mandatory && (typeof vendor[elname] === 'undefined' || vendor[elname] === '')) {
        form[elname].error = true;
        form[elname].errormsg = 'veuillez renseigner '+validator.name+'.';
        form.error++;
        console.log('vendor.elname: ', vendor);
      } else if (typeof vendor[elname] !== 'undefined' && vendor[elname].length > 60) {
        form[elname].error = true;
        form[elname].errormsg = validator.name+' est trop long : '+vendor[elname].length+' caractères, max. '+validator.maxlength+'.';
        form.error++;
        console.log('vendor.elname: ', vendor);
      } else {
        form[elname].error = false;
        form[elname].errormsg = '';
        console.log('vendor.elname, no error');
      }  
    }

   console.log('handleTextInputChange, done');
   this.setState({ config: config, articles: articles, vendor: vendor, form: form });

  }

  handleCountryCodeChange = (forcevalidation = false) => {

    let config = this.state.config;
    let articles = [...this.state.articles];
    let vendor = this.state.vendor;
    let form = this.state.form;

    if (this.state.form.countrycode.error || forcevalidation) {
      if (typeof vendor.countrycode === 'undefined') {
        form.countrycode.error = true;
        form.countrycode.errormsg = 'veuillez renseigner le pays.';
        form.error++;
      } else {
        form.countrycode.error = false;
        form.countrycode.errormsg = '';
      }      
    }
    this.setState({ config: config, articles: articles, vendor: vendor, form: form });
  }

  handleIdTypeChange = (forcevalidation = false) => {

    let config = this.state.config;
    let articles = [...this.state.articles];
    let vendor = this.state.vendor;
    let form = this.state.form;

    console.log('handleIdTypeChange / vendor.idtype: ', vendor.idtype);
    if (this.state.form.idtype.error || forcevalidation) {
      if (typeof vendor.idtype === 'undefined') {
        form.idtype.error = true;
        form.idtype.errormsg = 'veuillez renseigner le type de justificatif d\'identité.';
        form.error++;
      } else {
        form.idtype.error = false;
        form.idtype.errormsg = '';
      }      
    }
    this.setState({ config: config, articles: articles, vendor: vendor, form: form });
  }
  
  handleSubmit = (e) => {

    e.preventDefault();

    console.log('enter handleSubmit()');

    let config = this.state.config;
    let articles = [...this.state.articles];
    let vendor = this.state.vendor;
    let form = this.state.form;

    // submit button state
    //e.target.disabled = true;
    form.save.loading = true;
    form.save.disabled = true;
    form.save.content = 'Enregistrement en cours...';
    this.setState({ config: config, articles: articles, vendor: vendor, form: form });

    // form validation
    console.log('vendor.country: ', vendor);
    form.error = 0;
    form.articledescerr = 0;
    form.articlepriceerr = 0;
    this.handleTextInputChange('firstname');
    this.handleTextInputChange('lastname');
    this.handleTextInputChange('email');
    this.handleTextInputChange('address_1');
    this.handleTextInputChange('address_2');
    this.handleTextInputChange('address_3');
    this.handleTextInputChange('zipcode');
    this.handleTextInputChange('city');
    this.handleCountryCodeChange(true);
    this.handleIdTypeChange(true);
    this.handleTextInputChange('idnumber');


   console.log('checking errors for articles array');
    
   console.log('array size: ', articles.length);
   for (var i=0; i < articles.length; i++) {
    console.log('item i: ', i);
    console.log('description: ', articles[i].description);
    console.log('price: ', articles[i].price);
    articles[i].price = articles[i].price.replace(/[,]/g, ".");
      if (articles[i].description.trim() === '' && articles[i].price.trim() === '') {
        console.log('empty line at index, ignoring: ', i);
        articles.splice(i, 1);
        continue;
      }
      if (articles[i].description.trim() === '' && articles[i].price.trim() !== '') {
        console.log('description is empty at line ', i);
        form.articleslist.list[i].description_errormsg = 'veuillez renseigner la description de l\'article';
        form.articleslist.list[i].description_error = true;
        form.articledescerr++;
        console.log('form.error: ', form.error);
      } else if (articles[i].description.length > 55) {
        console.log('description is too long at line ', i);
        form.articleslist.list[i].description_error = true;
        form.articleslist.list[i].description_errormsg = 'la description de l\'article est trop longue: '+articles[i].description.length+' caractères, max. 25';
        form.articledescerr++;
        console.log('form.error: ', form.error);
      } else {
        console.log('no error on description at line ', i);
        form.articleslist.list[i].description_error = false;
        form.articleslist.list[i].description_errormsg = '';
        //form.articledescerr--;
        console.log('form.error: ', form.error);
      }

      if (articles[i].description.trim() !== '' && articles[i].price.trim() === '') {
        console.log('price is empty at line ', i);
        form.articleslist.list[i].price_error = true;
        form.articleslist.list[i].price_errormsg = 'veuillez renseigner le prix de l\'article';
        form.articlepriceerr++;
        console.log('form.articlepriceerr: ', form.articlepriceerr);
      } else if (articles[i].price.length > 8) {
        console.log('price is too long at line ', i);
        form.articleslist.list[i].price_error = true;
        form.articleslist.list[i].price_errormsg = 'le prix de l\'article est trop long: '+articles[i].price.length+' caractères, max. 8';
        form.articlepriceerr++;
        console.log('form.articlepriceerr: ', form.articlepriceerr);
      } else if (isNaN( articles[i].price )) {
        console.log('price must be a nunmber at line ', i);
        form.articleslist.list[i].error = true;
        form.articleslist.list[i].errormsg = 'le prix de l\'article est un nombre';
        form.articlepriceerr++;
        console.log('form.articlepriceerr: ', form.articlepriceerr);
      } else {
        form.articleslist.list[i].price_error = false;
        form.articleslist.list[i].price_errormsg = '';
        //form.articlepriceerr--;
        console.log('form.error: ', form.error);
      }
    }

    form.error = form.error + form.articledescerr + form.articlepriceerr;

    if (articles.length === 0) {
      articles = [{description:"", price:""}];
      form.articleslist.overview.error = true;
      form.articleslist.overview.errormsg = 'la liste des articles est vide, veuillez en saisir au moins un.';
      form.error++;
      console.log('articles list is empty');
      console.log('form.error: ', form.error);
      }

    console.log('final check form.error: ', form.error);    
    if (form.error > 0) {
      console.log('error, stopping', this.state);
      // submit button state
      //e.target.disabled = true;
      form.save.loading = false;
      form.save.disabled = false;
      form.save.content = 'Enregister les articles';
      this.setState({ config: config, articles: articles, vendor: vendor, form: form });
    } else {

    

    if (dev) {
      form.posted = true;
      vendor.preregid = '2020-TEST-TEST'
      this.setState({ config: config, articles: articles, vendor: vendor, form: form });

    } else {
    // begin online
    var preregid = -1;

    // database setup
    //migr --    const db = firebase.firestore();
    // firebase
    // TODO firebase config in external file
    var dbconfig = {
      apiKey: "AIzaSyA-ooj6Q6Z778EzSEIe8G4mEg04pZhtcWs",
      authDomain: "bourseskigex.firebaseapp.com",
      databaseURL: "https://bourseskigex.firebaseio.com",
      projectId: "bourseskigex",
      storageBucket: "bourseskigex.appspot.com",
      messagingSenderId: "802087787269"
    };

    const firebaseapp = initializeApp(dbconfig);
    const db = getFirestore(firebaseapp);

    /*
    db.settings({
      timestampsInSnapshots: true
    });
    */
    // preregister uid
    //var timestamp = new Date().getUTCMilliseconds();

    const configDoc = getDoc(doc(db, "config", this.state.config.current_year)).then(
      (configref) => {
        console.log('getting configref / preregid: ', configref.data().preregid);
        preregid = configref.data().preregid;
      
      }).then( // then configDoc
              () => {
                preregid = preregid + 1;
                console.log("saving updated preregid");
                console.log("setting preregid to:" + preregid);
                const newPreregIdUpdate = setDoc(doc(db, "config", this.state.config.current_year), {
                  preregid: preregid
                }).then(
                      () =>{
                      console.log("preregid successfully updated!", preregid);
                      preregid = this.state.config.current_year + '-' + preregid;
                      console.log('PREREG-ID: ', preregid);
                      vendor.preregid = preregid;
                      vendor.preregdate = new Date();

                      //articles
                      for (var i=0; i < articles.length; i++) {
                      if (articles[i].description.trim() === '' && articles[i].price.trim() === '') {
                      console.log('empty line at index, ignoring: ', i);
                      articles.splice(i, 1);
                      }
                      }
                      if (articles.length > 0) {
                      vendor.articles = articles;
                      }

                        //saving vendor
                        const newVendorId = addDoc(collection(db, "vendors"), vendor)
                        .then(
                          (vendorref) => {
                          console.log('firestore write done for vendors, id:', newVendorId);
                          //save done
                          form.posted = true;
                          this.setState({ config: config, articles: articles, vendor: vendor, form: form });
                          }
                        );
                        
                  } 
                );
              }
              );// end then configDoc


    }// end online
    }

  }


  // Start render

    render () {
      let {articles} = this.state;
      let {vendor} = this.state;
      console.log('rendering parent > this.state.articles:', articles);
      console.log('STATUS  > this.state.status: ', this.state.config.status);
      this.logState();
  
      if (this.state.config.status === 'UNKNOWN') {
        return (
          <Grid stackable>
            <Grid.Row centered>
              <Grid.Column centered verticalAlign='middle' width={16}>
              <Image centered src={gscLogo} />
              <Header as='h2' content="LOADING ... " />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )
      }
  
      if (this.state.config.status === 'CLOSED') {
        return (
          <Grid stackable>
            <Grid.Row centered>
              <Grid.Column centered verticalAlign='middle' width={16}>
              <Image centered src={gscLogo} />
              <Header as='h1'>{this.state.config.txt_nextevent_title}</Header>
              <Header as='h2'>{this.state.config.txt_nextevent_line1}</Header>
              <Header as='h2'>{this.state.config.txt_nextevent_line2}</Header>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )
      }
      if (this.state.config.status === 'PREOPEN') {
        return (
          <Grid stackable>
            <Grid.Row centered>
              <Grid.Column centered verticalAlign='middle' width={16}>
              <Image centered src={gscLogo} />
              <Header as='h1'>{this.state.config.txt_preopen_title}</Header>
              <Header as='h2'>{this.state.config.txt_preopen_line1}</Header>
              <Header as='h2'>{this.state.config.txt_preopen_line2}</Header>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )
      }
      if (this.state.form.posted) {
        return (
          <div>
          <PreRegisterConfirm preregid={this.state.vendor.preregid} vendor={vendor} articles={articles} config={this.state.config}/>
        </div>
        );
      }
      return(
  <div className="form-block">
  <Form onChange={this.handleChange}>
  {/*<Segment only='computer' raised>*/}
  
  {/* migr -- <Responsive as={Segment} only='computer'> */}
  <Segment.Group>
  <Segment as={Media} at="computer">
  <Grid stackable>
  <Grid.Row>
  <Grid.Column width={6}>
  <Image src={gscLogo} />
  </Grid.Column>
  <Grid.Column verticalAlign='middle' width={10}>
  <Header as='h1' content={this.state.config.txt_form_title} />
  <Header as='h2' content={this.state.config.txt_form_subtitle} />
  </Grid.Column>
  </Grid.Row>
  <Grid.Row>
  <Grid.Column textAlign='justified' width={16}>
  <p>{this.state.config.txt_form_label1}</p>
  <p><b>Attention:</b> cette procédure ne vous dispense pas du dépôt physique des matériels {this.state.config.txt_form_datetime_deposit}.</p>
  </Grid.Column>
  </Grid.Row>
  </Grid>
    {/* <Message
        icon='warning sign'
        color='orange'
        header='COVID-19 : AUCUN TEXTILE ne pourra être mis en vente.'
        content={'Dû aux mesures sanitaires en vigueur, les chaussures de ski et après-ski sont autorisés. Les vêtements, chaussettes, gants, casques exclus.'}
      
      </Message>
    */}
    {/* <Message
    <Message
      icon='warning sign'
      color='orange'
      header='COVID-19 : Pass sanitaire et masque obligatoires.'
      content={'Les directives sanitaires gouvernementales et de la municipalité de Gex imposent le port du masque ainsi que la présentation d\'un pass sanitaire valable pour accèder à l\'espace perdtemps.'}  >
    </Message>
    */}
  <Divider hidden />
  <Label as='h1' color='grey' ribbon>
  Coordonnées vendeur:
  </Label>
  <Divider hidden />
  <Form.Group>
  <Form.Field error={this.state.form.firstname.error} width={8}>
  <label>Prénom*</label>
  <input placeholder='First name' name="firstname" value={this.state.vendor.firstname} onChange={this.handleTextInputChange} />
  {this.state.form.firstname.error ? <Label pointing color='red'>{this.state.form.firstname.errormsg}</Label> : null}
  </Form.Field>
  <Form.Field error={this.state.form.lastname.error} width={8}>
  <label>Nom*</label>
  <input placeholder='Last name' name="lastname" value={this.state.vendor.lastname} onChange={this.handleTextInputChange} />
  {this.state.form.lastname.error ? <Label pointing color='red'>{this.state.form.lastname.errormsg}</Label> : null}
  </Form.Field>
  </Form.Group>
  <Form.Field error={this.state.form.email.error} width={16}>
  <label>Email*</label>
  <input placeholder='Email address' name="email" value={this.state.vendor.email} onChange={this.handleTextInputChange}/>
  {this.state.form.email.error ? <Label pointing color='red'>{this.state.form.email.errormsg}</Label> : null}
  </Form.Field>
  <Form.Field error={this.state.form.address_1.error} width={16}>
  <label>Adresse postale*:</label>
  {this.state.form.address_1.error ? <Label pointing='below' color='red'>{this.state.form.address_1.errormsg}</Label> : null}
  <input placeholder='Adress 1*' name="address_1" value={this.state.vendor.address_1} onChange={this.handleTextInputChange} />
  </Form.Field>
  <Form.Field error={this.state.form.address_2.error} width={16}>
  {this.state.form.address_2.error ? <Label pointing='below' color='red'>{this.state.form.address_2.errormsg}</Label> : null}
  <input placeholder='Adress 2' name="address_2" value={this.state.vendor.address_2} onChange={this.handleTextInputChange} />
  </Form.Field>
  <Form.Field error={this.state.form.address_3.error} width={16}>
  {this.state.form.address_3.error ? <Label pointing='below' color='red'>{this.state.form.address_3.errormsg}</Label> : null}
  <input placeholder='Adress 3' name="address_3"  value={this.state.vendor.address_3} onChange={this.handleTextInputChange}/>
  </Form.Field>
  <Form.Group>
  <Form.Field error={this.state.form.lastname.error} width={4}>
  <label>Code Postal*</label>
  <input placeholder='Zip code' name="zipcode"  value={this.state.vendor.zipcode} onChange={this.handleTextInputChange}/>
  {this.state.form.zipcode.error ? <Label pointing color='red'>{this.state.form.zipcode.errormsg}</Label> : null}
  </Form.Field>
  <Form.Field error={this.state.form.lastname.error ? true : undefined} width={7}>
  <label>Ville*</label>
  <input placeholder='City' name="city"  value={this.state.vendor.city} onChange={this.handleTextInputChange} />
  {this.state.form.city.error ? <Label pointing color='red'>{this.state.form.city.errormsg}</Label> : null}
  </Form.Field>
  <Form.Field error={this.state.form.countrycode.error} width={5}>
  <label>Pays*</label>
  <Form.Select compact options={countryOptions} placeholder='Select country' name='countrycode' onChange={this.handleChangeCountry}/>
  {this.state.form.countrycode.error ? <Label pointing color='red'>{this.state.form.countrycode.errormsg}</Label> : null}
  </Form.Field>
  </Form.Group>
  <Form.Group>
  <Form.Field error={this.state.form.idtype.error} width={8} >
  <label>Justificatif d&apos;identité*</label>
  <Form.Select compact options={identityOptions} placeholder='Sélectionner le type de document' name='idtype'onChange={this.handleChangeIdType}/>
  {this.state.form.idtype.error ? <Label pointing color='red'>{this.state.form.idtype.errormsg}</Label> : null}
  </Form.Field>
  <Form.Field error={this.state.form.idnumber.error ? true : undefined} width={8} >
  <label>Numéro du justificatif*</label>
  <input placeholder='ID Number' name="idnumber" value={this.state.vendor.idnumber} onChange={this.handleTextInputChange} />
  {this.state.form.idnumber.error ? <Label pointing color='red'>{this.state.form.idnumber.errormsg}</Label> : null}
  </Form.Field>
  </Form.Group>
  
  
  
  
  <Divider hidden />
  <Label as='h1' color='orange' ribbon>
  Liste du matériel mis en vente:
  </Label>      
  <br/>
  <br/>
  <Grid stackable error={this.state.form.articleslist.overview.error ? true : undefined} columns={4}>
  <Grid.Row >
  <Grid.Column width={16}>
  Dans la mesure du possible, veuillez formuler la description de l&apos;article ainsi : <br/>
  <b>TYPE ARTICLE, TAILLE, MARQUE, MODELE, COULEUR</b><br/>
  La longueur de la description est limitée à 55 caractères. La description apparaîtra sur l'étiquette de l'article.<br/>
  Ex:<br/>
  <i>Skis 170 Movement Black Apple rouge</i><br/>
  <i>Chaussures Ski 42 Rossignol Hero WC blanches</i><br/>
  <br/>
  Pour les chaussures de ski, veuillez indiquer la taille en <b>pointure européenne</b>. Vous pouvez utiliser ces correspondances: <Dropdown placeholder='Mondopoint <-> EUR' options={shoeSizeOptions} />
  
  </Grid.Column>
  </Grid.Row>
  <Grid.Row only='computer tablet'>
  <Grid.Column width={1}>
  #
  </Grid.Column>
  <Grid.Column  width={9}>
  Description
  </Grid.Column>
  <Grid.Column  width={3}>
  Prix (euros)
  </Grid.Column>
  <Grid.Column  width={3}>
  
  </Grid.Column>
  </Grid.Row>
  {/*<Grid.Row only='mobile'>
  <Grid.Column width={16}>
  ###TODO### La description est limitée à 24 caractères, dans la mesure du possible veuillez formuler votre description selon cette nomenclature :
  TYPE - TAILLE - DESIGNATION
  https://f2.quomodo.com/F350D532/uploads/8531/Fiche%20depose%20materiel%20Bourse%20aux%20skis.pdf
  SKI -- Ski alpin
  </Grid.Column>
  </Grid.Row>
  */}
  
  {/* articles dynamic list */}
  {
    articles.map((val, idx)=> {
    let articleDesc = `description-${idx}`, articlePrice = `price-${idx}`
    return (
    <Grid.Row>
    <Grid.Column only='computer tablet'right aligned verticalAlign='middle' column width={1}>
    {idx+1}
    </Grid.Column>
    <Grid.Column only='mobile'right aligned verticalAlign='middle' column width={1}>
    Article {idx+1}
    </Grid.Column>
    <Grid.Column width={9}>
    <Input
    fluid
    max={55}
    type = 'text'
    value={this.state.articles[idx].description}
    label = {{ basic: true, size: 'mini', color: this.state.form.articleslist.list[idx].description_size_alert, content: this.state.form.articleslist.list[idx].description_size }}
    labelPosition= 'right'
    name={articleDesc}
    data-id={idx}
    data-type='article'
    id={articleDesc}
    className="description"
    placeholder='Description* : TYPE ARTICLE, TAILLE, MARQUE, MODELE, COULEUR'
    />
    {this.state.form.articleslist.list[idx].description_error ? <Label pointing color='red'>{this.state.form.articleslist.list[idx].description_errormsg}</Label> : null}
    </Grid.Column>
    <Grid.Column  width={3}>
    <input
    type='text'
    value={this.state.articles[idx].price}
    name={articlePrice}
    id={articlePrice}
    data-id={idx}
    className='price'
    placeholder='Prix*'
    />
    {this.state.form.articleslist.list[idx].price_error ? <Label pointing color='red'>{this.state.form.articleslist.list[idx].price_errormsg}</Label> : null}
    </Grid.Column>
    <Grid.Column  width={3}>
    <Button artid={idx} onClick={this.showRemoveArticleConfirm} animated='vertical'>
    <Button.Content hidden><Icon name='warning sign' color='orange' /></Button.Content>
    <Button.Content visible>
    <Icon name='trash'   />
    </Button.Content>
    </Button>
    <Confirm
            open={this.state.form.articleslist.list[idx].deleteConfirm}
            content='Suppression de l&apos;article ?'
            artid={idx}
            size='mini'
            cancelButton='Annuler'
            confirmButton="Confirmer"
            onCancel={this.hideRemoveArticleConfirm}
            onConfirm={this.removeArticle}
          />
  
    </Grid.Column>
    </Grid.Row>
    )
    })
    }
  
  {this.state.form.articleslist.overview.error ? <Label pointing color='red'>{this.state.form.articleslist.overview.errormsg}</Label> : null}
  </Grid>
  <Divider hidden />
  
  <Button onClick={this.addArticle} content='Ajouter un article' icon='add' labelPosition='left' color='orange' floated="right" size='mini'/>
  
  <Divider hidden />
  <Divider hidden />
  <Divider hidden />
  <Label as='h1' color='black' ribbon>
  Validation:
  </Label>
  <Divider hidden />
  
  <p>Si vous avez saisi tous les articles que vous souhaitez déposer, il vous reste à enregistrer votre saisie.</p>
  <p>Un droit de dépôt sera perçu au moment de la dépose des matériels, le club garde une commission de 16% sur les ventes.</p>
  <p><b><i>En cliquant sur le bouton '{this.state.form.save.content}' , vous acceptez d'être contacté par email par le Gex Ski Club pour le suivi de la bourse aux skis. Votre email ne sera pas transmis à des tiers.</i></b></p>
  {/*<Form.Field>
  <Checkbox label='J&apos;accepte les conditions de vente.' name='optin'/>
  </Form.Field>*/}
  
  
  {this.state.form.error > 0 ?
  <Message negative>
  <Message.Header>Erreur{this.state.form.error > 1 ? 's' : null} dans le formulaire</Message.Header>
  <p>Certaines saisies sont incorrectes ou manquantes, veuillez corriger avant d&apos;enregistrer à nouveau pour valider votre saisie.</p>
  </Message>
  : null
  }
  <ReCaptcha
  ref={(el) => {this.captchaDemo = el;}}
  size="normal"
  render="explicit"
  sitekey="6LdI1XUUAAAAAFzXlMNmkmmqTTNBVYDLR6zap6EV"
  onloadCallback={this.onLoadRecaptcha}
  verifyCallback={this.verifyCallback}
  />
  
  <Button color='orange' fluid onClick={this.handleSubmit} content={this.state.form.save.content} disabled={this.state.form.save.disabled} loading={this.state.form.save.loading}/>
  <br/>
  {/*<Button onClick={this.logState}>State</Button>
  <Button onClick={this.testfunc}>Test</Button>*/}
  
  
  {/*</Segment>*/}
  { /* migr -- </Segment.Group></Responsive> */ }
  </Segment>
  </Segment.Group>
  
  </Form>
    </div>      
  
      );
    }

}

export default PreRegisterForm;

